<template>
  <a
    v-if="data.url"
    :href="data.url"
    class="flex justify-center items-center cursor-pointer bg-white w-full shadow-xl py-3 mx-3 mt-2 lg:mt-0 rounded-full text-[#0066FF]"
    rel="noopener noreferrer nofollow"
    target="_blank"
  >
    {{ data.title }}
    <div class="w-5 mr-2 flex items-center">
      <Icon :name="data.icon" color="text-[#0066FF]" />
    </div>
  </a>
  <div
    v-else-if="data.modalId"
    class="flex justify-center items-center pointer bg-white w-full shadow-xl py-3 mx-3 mt-2 lg:mt-0 rounded-full text-[#0066FF]"
    @click="openModal"
  >
    <div class="font-bold text-sm flex justify-center items-center">
      <div class="me-2">{{ data.title }}</div>
      <div class="w-5">
        <Icon :name="data.icon" color="text-[#0066FF]" />
      </div>
    </div>
  </div>
  <div
    v-else
    class="flex justify-center items-center pointer bg-white w-full shadow-xl py-3 mx-3 mt-2 lg:mt-0 rounded-full text-[#0066FF]"
  >
    <div class="font-bold text-sm flex justify-center items-center">
      <div class="me-2">{{ data.title }}</div>
      <div class="w-5">
        <Icon :name="data.icon" color="text-[#0066FF]" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  data: Object,
});

const isModalShowed = ref(false);

const openModal = () => {
  isModalShowed.value = true;
  document.body.style.overflow = "hidden";
};
</script>
